import request from '@h3/request';
import { H3 } from '@h3/types';
export function loadFrequentlyApps() {
    return request('/v1/userfrequentlyapp/list', {
        method: H3.Http.MethodType.GET,
    });
}
export function updateFrequentlyApps(data) {
    return request('/v1/userfrequentlyapp/save', {
        method: H3.Http.MethodType.POST,
        data: {
            frequentlyApps: data,
        },
    });
}
